import { h, Fragment } from "preact";
import { useState } from "preact/hooks";

import LoginSignupTemplate from "../../LoginSignupTemplate";
import SignupForm from "../../forms/SignupForm";
import SignupParams from "../../types/SignupParams";
import FigmaSSOButton from "../../FigmaSSOButton";
import GoogleSSOButton from "../../GoogleSSOButton";
import { urlResolve } from "../../../../../foundation/utils/url";
import ResponsiveImage from "../../../../../library/ResponsiveImage";
import BasicRecord from "../../../../../foundation/utils/BasicRecord";
import getRedirectUrl from "../../../../../foundation/utils/get-redirect-url";

import "./style.css";

interface Props {
    signupParams: SignupParams;
    signupToken: string;
}

export function SignupPage({ signupParams, signupToken }: Props) {
    const [handle, setHandle] = useState("");
    const { workspaceName } = signupParams;
    const ssoQuery: BasicRecord = { action: "signup" };
    const redirectToFromSession = signupParams.redirect || sessionStorage.getItem("redirectTo");
    if (redirectToFromSession) {
        ssoQuery["redirect"] = getRedirectUrl(redirectToFromSession, "/");
    }

    // TODO: Fix this after workspace name is correctly encoded in the backend
    const header = workspaceName
        ? <>You're invited to <br/>{workspaceName.replace(/\+/g, " ")}</> : "Welcome to Zeplin!";

    return (
        <LoginSignupTemplate
            illustration={<ResponsiveImage asset="img/onboarding-illustration-1.png"/>}
            displayIllustrationOnMobile={false}
            header={header}
            subHeader="We're so happy you're here, let’s start by signing up."
            actionButtons={(
                <>
                    <FigmaSSOButton
                        type="signup"
                        query={ssoQuery}/>
                    <GoogleSSOButton
                        type="signup"
                        query={ssoQuery}/>
                </>
            )}
            form={<SignupForm signupParams={signupParams} signupToken={signupToken} onHandleChange={setHandle}/>}
            footer={<span class="signupPageFooter">Already have an account? <a href={urlResolve("login", { query: { email: handle } })}>Login</a></span>}/>
    );
}

export default SignupPage;

